"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.explicitDecoder = exports.pipResponseValidatorDecoder = exports.authStateParseDecoder = exports.tokenValidatorDecoder = exports.logoutParamsValidationDecoder = exports.loginParamsValidationDecoder = exports.tokensFetcherDecoder = exports.tokenRefresherDecoder = void 0;
var t = __importStar(require("io-ts"));
exports.tokenRefresherDecoder = t.literal("REFRESH_TOKEN_REQUEST_FAILED");
exports.tokensFetcherDecoder = t.union([
    t.literal("TOKEN_REQUEST_FAILED"),
    t.literal("MISSING_TOKEN_RESPONSE_COOKIE"),
    t.literal("MISSING DPG-COMPONENT-AT COOKIE")
]);
exports.loginParamsValidationDecoder = t.union([
    t.literal("PIP_ERROR"),
    t.literal("MISSING_CODEVERIFIER"),
    t.literal("INVALID_STATE"),
    t.literal("INVALID_CODE"),
    t.literal("MISSING_NONCE"),
    t.literal("INVALID_NONCE"),
    t.literal("MISSING_EXP"),
    t.literal("INVALID_JWT_AT"),
    t.literal("MISSING AUTHSTATE COOKIE")
]);
exports.logoutParamsValidationDecoder = t.union([
    t.literal("LOGOUT_INVALID_PARAMS"),
    t.literal("LOGOUT_INVALID_STATE"),
    t.literal("LOGOUT_INVALID_JSON"),
]);
//TODO: Get rid of this and use TokenValidator only
exports.tokenValidatorDecoder = t.union([
    t.literal("EMPTY_TOKEN"),
    t.literal("INVALID_SIGNATURE"),
    t.literal("INVALID_JWT_PROPERTIES"),
]);
exports.authStateParseDecoder = t.union([
    t.literal("AUTH_STATE_PARSE_NO_COOKIE"),
    t.literal("AUTH_STATE_PARSE_INVALID_JSON_STRUCTURE"),
    t.literal("AUTH_STATE_PARSE_INVALID_JWT_STRING"),
    t.literal("MISSING DPG-COMPONENT-AT COOKIE"),
    t.literal("MISSING DPG-COMPONENT-UIT COOKIE")
]);
//TODO: Get rid of this and use PipResponseValidator only
exports.pipResponseValidatorDecoder = t.union([
    t.literal("PIP_RESPONSE_EMPTY"),
    t.literal("PIP_RESPONSE_INVALID_JSON"),
    t.literal("PIP_RESPONSE_INVALID_STRUCTURE"),
]);
exports.explicitDecoder = t.literal("EXPLICIT");
